module.exports = __webpack_public_path__ + "static/media/farm_4_auth_bg.119633bb.png";